import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  hover?: boolean;
}
export function Card({
  children,
  className = '',
  hover = false
}: CardProps) {
  return <div className={`
        bg-white rounded-xl border border-gray-100 shadow-sm overflow-hidden
        ${hover ? 'transition-all duration-300 hover:shadow-lg hover:-translate-y-1' : ''}
        ${className}
      `} data-id="element-105">
      {children}
    </div>;
}